/*
categories menu
AT
04.06.21
*/

import CategoriesMenu from './categories-menu.svelte'

const categoriesMenu = new CategoriesMenu({
	target: document.querySelector('#categories-menu'),
	//props: { }
})

export default categoriesMenu